import dynamic from 'next/dynamic';
import { memo, useRef } from 'react';

import { AllContentHeaderBar } from '~/components/AllContent/AllContentHeaderBar';
import { AllContentView } from '~/components/AllContent/AllContentView';
import { PrivateFiltersReduxObserver } from '~/components/Filters/PrivateFiltersReduxObserver';
import { SCROLL_CONTAINER_ID } from '~/components/TableView/ui';
import { ALL_CONTENT_PAGE_CONTENT } from '~/constants/testIDs';

const AllContentViewControls = dynamic(
  () => import('~/components/AllContent/AllContentViewControls').then((mod) => mod.AllContentViewControls),
  {
    ssr: false,
  },
);

export const AllContent = memo(() => {
  const mainRef = useRef<HTMLDivElement | null>(null);
  const headerRef = useRef<HTMLDivElement | null>(null);

  return (
    <div
      id={SCROLL_CONTAINER_ID}
      className="flex flex-1 flex-col overflow-y-auto"
      data-testid={ALL_CONTENT_PAGE_CONTENT}
      ref={mainRef}
    >
      <PrivateFiltersReduxObserver />
      <AllContentHeaderBar headerRef={headerRef} />
      <AllContentViewControls headerRef={headerRef} />
      <AllContentView scrollElementRef={mainRef} />
    </div>
  );
});

AllContent.displayName = 'AllContent';
